import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dotToComma',
})
export class DotToCommaPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string | null {
    if (value == null) {
      return null;
    }

    const stringValue = typeof value === 'number' ? value.toString() : value;
    return stringValue.replace(/\./g, ',');
  }
}
